export const prepareDataForApi = (data: object) => ({
    /* eslint-disable @typescript-eslint/no-explicit-any */
    ...Object.entries(data).reduce((acc, [key, val]: [string, any]) => {
        return {
            ...acc,
            [key]: val instanceof Date ? val.toJSON() : val,
        }
    }, {}),
})

/**
 * @param data Check if the retrieved data has firestore date format (_seconds, _nanoseconds)
 * If so, convert the firestore date to js date
 */
const keysToGuessAsDate = ['date', 'lastModifiedDate']
export const convertDataFromApi = (data: object, isDateObject = true) => ({
    /* eslint-disable @typescript-eslint/no-explicit-any */
    ...Object.entries(data).reduce((acc, [key, val]: [string, any]) => {
        return isDateObject
            ? {
                  ...acc,
                  [key]: val && val._seconds ? new Date(val._seconds * 1000) : val,
              }
            : {
                  ...acc,
                  [key]: val && keysToGuessAsDate.includes(key) ? new Date(val) : val,
              }
    }, {}),
})
